import React from 'react';
import styled from 'styled-components/macro';
import { Row, Icon } from 'antd';

import Button from 'components/Button/Button';
import Heading from 'components/Heading/Heading';
import Description from 'components/Description/Description';
import WebBackgroundImage from './images/web-bg.svg';
import MobileBackgroundImage from './images/mobile-bg.svg';

const MainContainer = styled(Row)`
  background: url(${MobileBackgroundImage}) no-repeat center center;
  background-size: cover;
  height: 100% !important;
  padding-top: 80px;
  padding-bottom: 8%;
  min-height: 720px;

  @media (min-width: 768px) {
    padding-top: 8%;
    background: url(${WebBackgroundImage}) no-repeat center bottom;
    background-size: cover;
    display: flex;
  }
  @media (min-width: 1200px) {
    height: 900px !important;
  }
  @media (min-width: 1600px) {
    background-size: cover;
    background: url(${WebBackgroundImage}) no-repeat center top;
    height: 104vh !important;
  }
`;

const ContentDiv = styled.div`
  width: 100%;
  text-align: center;
  margin: 8% auto;
  @media (min-width: 768px) {
    width: 60%;
    text-align: center;
    margin: 8% auto;
  }
  @media (min-width: 992px) {
    width: 50%;
    text-align: center;
    margin: 8% auto;
  }
  @media (min-width: 1200px) {
    margin: 4% auto;
  }
`;

const Enquiry = () => {
  return (
    <MainContainer>
      <ContentDiv>
        <Heading color="white" align="center">
          Enquiry?
        </Heading>
        <Description size="large" color="white" align="center">
          Drop us a message & we will get back to you as soon as possible!
        </Description>
        <Button type="cta" size="large" toUrl="/enquiry" prevUrl="/">
          Contact us <Icon type="right" />
        </Button>
      </ContentDiv>
    </MainContainer>
  );
};

export default Enquiry;
